import { takeLatest, call, put } from 'redux-saga/effects';
import { CREATE_WEB_PUSH_USER_ON_SERVER } from './actionTypes';
import webPushApiNotifications from '~/sdk/notifications/webPush/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import { setSubscriptionId } from '~/NotificationsManager/webPush/Authentication/actions';

const notificationsApiDefault = new webPushApiNotifications(clientConfig.notificationApi);

export default function sagasModule(notificationsApi = notificationsApiDefault) {
  function setPHPCompatilbleStorage(subscriptionId) {
    // https://jira.services/browse/PROD-1069
    const simpleStorageData = {
      pushNotification: {
        customPermissionsCloseCounter: 1,
        id: 'pushNotification',
        layerAlreadyShowed: true,
        pushUserId: subscriptionId,
        searches: {},
        userAllowsPushes: true,
      },
    };

    const simpleStorage = localStorage.getItem('simpleStorage');
    const parsedSimpleStorage = simpleStorage ? JSON.parse(simpleStorage) : {};
    const newSimpleStorage = JSON.stringify({ ...parsedSimpleStorage, ...simpleStorageData });

    localStorage.setItem('simpleStorage', newSimpleStorage);
  }

  function* createWebPushUserOnServerSaga({ payload }) {
    const { subscription, countryCode, verticalId, installationId, pageViewId } = payload;

    const data = {
      country: countryCode,
      verticalId,
      endpoint: subscription.toJSON().endpoint,
      'authKeys%5Bp256dh%5D': subscription.toJSON().keys.p256dh,
      'authKeys%5Bauth%5D': subscription.toJSON().keys.auth,
      cookieId: installationId,
      deviceTypeId: 2,
      browser: 2,
      pageViewId,
    };

    try {
      const result = yield call([notificationsApi, notificationsApi.subscribeUserV3], data);

      const subscriptionId = result.message.split(':')[1];

      setPHPCompatilbleStorage(subscriptionId);

      yield put(setSubscriptionId(subscriptionId));
    } catch (error) {
      console.log(error);
    }
  }

  function* sagas() {
    yield takeLatest(CREATE_WEB_PUSH_USER_ON_SERVER, createWebPushUserOnServerSaga);
  }

  return {
    createWebPushUserOnServerSaga,
    sagas,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/settings/sagas.js